import { render, staticRenderFns } from "./ListCustomer.vue?vue&type=template&id=ea42468a&scoped=true&"
import script from "./ListCustomer.vue?vue&type=script&lang=js&"
export * from "./ListCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea42468a",
  null
  
)

export default component.exports